<!-- Inner tabs -->
<div class="px-2 px-sm-3 pt-2 pb-2 border-bottom flex-shrink-0">
  <div class="knxm-tabs" role="tablist">
    <button *ngFor="let t of tabs; trackBy: trackTab"
            type="button" role="tab"
            class="nav-tab-btn py-1 px-1 px-sm-3 px-lg-2 rounded-3 border-0 small fw-semibold"
            [class.active]="tab === t.key"
            [attr.aria-selected]="tab === t.key"
            [title]="t.label | translate"
            (click)="setTab(t.key)"><span class="knxm-tab-icon">{{ t.icon }}</span><span class="knxm-tab-label d-lg-none">{{ t.short | translate }}</span><span class="knxm-tab-label d-none d-lg-block">{{ t.label | translate }}</span></button>
  </div>
</div>

<ng-container [ngSwitch]="tab">

  <!-- ═══ Live ═══ -->
  <div *ngSwitchCase="'live'" class="knxm-pane">
    <div class="knxm-bar knxm-live-bar px-2 px-sm-3 py-2 border-bottom flex-shrink-0">
      <button type="button" class="btn btn-sm text-nowrap m-touch-sm knxm-pause"
              [class.btn-outline-secondary]="!paused" [class.btn-warning]="paused"
              (click)="togglePause()">{{ paused ? '▶' : '⏸' }} {{ (paused ? 'ADMIN_KNX_RESUME' : 'ADMIN_KNX_PAUSE') | translate }}</button>
      <input type="search" class="form-control form-control-sm knxm-q"
             [(ngModel)]="liveQ" (ngModelChange)="liveFilterChanged()"
             [placeholder]="'ADMIN_KNX_FILTER' | translate">
      <select class="form-select form-select-sm knxm-sel" [(ngModel)]="liveApci" (ngModelChange)="liveFilterChanged()">
        <option value="">{{ 'ADMIN_KNX_ALL_APCI' | translate }}</option>
        <option *ngFor="let a of apciOptions" [value]="a">{{ a }}</option>
      </select>
      <!-- One unit: on a phone both boxes move to the next row together -->
      <div class="knxm-checks">
        <div class="form-check m-0 knxm-check">
          <input class="form-check-input" type="checkbox" id="knxmOnlyGroups" [(ngModel)]="onlyGroups" (ngModelChange)="liveFilterChanged()">
          <label class="form-check-label" for="knxmOnlyGroups">{{ 'ADMIN_KNX_ONLY_GROUPS' | translate }}</label>
        </div>
        <div class="form-check m-0 knxm-check">
          <input class="form-check-input" type="checkbox" id="knxmAutoScroll" [(ngModel)]="autoScroll">
          <label class="form-check-label" for="knxmAutoScroll">{{ 'ADMIN_KNX_AUTOSCROLL' | translate }}</label>
        </div>
      </div>
      <button type="button" class="btn btn-sm btn-outline-secondary m-touch-sm knxm-clear" (click)="clearLive()"
              [title]="'ADMIN_KNX_CLEAR' | translate" [attr.aria-label]="'ADMIN_KNX_CLEAR' | translate">⌫</button>
      <span class="knxm-stats ms-sm-auto">
        <ng-container *ngIf="status as st">
          <span class="knxm-dot" [class.bg-success]="st.s.listening" [class.bg-danger]="!st.s.listening"
                [title]="(st.s.listening ? 'ADMIN_KNX_LISTENING' : 'ADMIN_KNX_NOT_LISTENING') | translate"></span>
          <b class="text-body">{{ fmtNum(st.s.ratePerMin) }}</b>/min · {{ fmtNum(st.s.total) }} {{ 'ADMIN_KNX_TOTAL' | translate }} ·
        </ng-container>
        {{ 'ADMIN_KNX_SHOWN' | translate:{ shown: liveView.length, total: liveCount } }}
        <span *ngIf="gap" class="text-warning-emphasis" [title]="'ADMIN_KNX_GAP_HINT' | translate"> · ⚠ {{ 'ADMIN_KNX_GAP' | translate }}</span>
      </span>
    </div>
    <div *ngIf="liveError" class="alert alert-danger py-1 px-2 m-2 mb-0 small flex-shrink-0">{{ 'ADMIN_KNX_ERROR' | translate:{ msg: liveError } }}</div>
    <div class="knxm-scroll" #liveScroll>
      <ng-container *ngTemplateOutlet="telegramTable; context: { $implicit: liveView, withDate: false }"></ng-container>
      <div *ngIf="!liveView.length" class="text-muted small text-center py-4 px-3">
        {{ (liveCount ? 'ADMIN_KNX_NO_MATCH' : 'ADMIN_KNX_NO_TELEGRAMS') | translate }}
      </div>
    </div>
  </div>

  <!-- ═══ Geräte & Topologie (learned passively; polls every 30 s while shown) ═══ -->
  <div *ngSwitchCase="'topology'" class="knxm-pane">
    <div class="knxm-bar px-2 px-sm-3 py-2 border-bottom flex-shrink-0">
      <input type="search" class="form-control form-control-sm knxt-q"
             [(ngModel)]="topoQ" (ngModelChange)="topoFilterChanged()"
             [placeholder]="'ADMIN_KNX_TOPO_FILTER' | translate">
      <span class="knxm-stats me-auto">{{ 'ADMIN_KNX_SHOWN' | translate:{ shown: topoShown, total: topoDeviceCount } }} {{ 'ADMIN_KNX_TOPO_DEVICES' | translate }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary m-touch-sm" (click)="refreshTopology()"
              [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
    </div>
    <div class="knxm-scroll p-2 p-sm-3">
      <!-- Learning status -->
      <div class="knxm-hint mb-2">
        <div *ngIf="topoLoaded" class="text-body">🧠 {{ topoLearned }}</div>
        <div *ngIf="topoReplay" [class.text-warning-emphasis]="topoReplayRunning">
          <span *ngIf="topoReplayRunning" class="spinner-border spinner-border-sm me-1" style="width:.6rem;height:.6rem;border-width:.1em;"></span>{{ topoReplay }}
        </div>
        <div>🔒 {{ 'ADMIN_KNX_TOPO_PASSIVE' | translate }}</div>
      </div>
      <div *ngIf="topoError" class="alert alert-danger py-1 px-2 small">{{ 'ADMIN_KNX_ERROR' | translate:{ msg: topoError } }}</div>
      <div *ngIf="!topoLoaded && !topoError" class="text-muted small text-center py-4">{{ 'ADMIN_KNX_LOADING' | translate }}</div>
      <div *ngIf="topoLoaded && !topoDeviceCount" class="text-muted small text-center py-3">{{ 'ADMIN_KNX_TOPO_EMPTY' | translate }}</div>

      <!-- a) Diagram -->
      <div *ngIf="topoSvg as svg" class="card mb-3">
        <div class="card-body p-2 p-sm-3">
          <div class="d-flex flex-wrap align-items-baseline gap-2 mb-2">
            <span class="knxm-card-title me-auto">{{ 'ADMIN_KNX_TOPO_DIAGRAM' | translate }}</span>
            <span class="knxm-hint">{{ 'ADMIN_KNX_TOPO_CLICK_HINT' | translate }}</span>
          </div>
          <div class="knxt-svg-wrap">
            <svg class="knxt-svg" xmlns="http://www.w3.org/2000/svg" role="img"
                 [attr.width]="svg.w" [attr.height]="svg.h" [attr.viewBox]="'0 0 ' + svg.w + ' ' + svg.h"
                 [attr.aria-label]="'ADMIN_KNX_TOPO_DIAGRAM' | translate">
              <path class="knxt-ip" [attr.d]="svg.ipPath"></path>
              <path class="knxt-tp" [attr.d]="svg.tpPath"></path>
              <!-- IP side: our listener, HomeServer, other IP senders -->
              <g *ngFor="let n of svg.nodes" class="knxt-node" [class.listener]="n.listener">
                <title>{{ n.tip }}</title>
                <rect [attr.x]="n.x" [attr.y]="n.y" [attr.width]="n.w" [attr.height]="n.h" rx="7"></rect>
                <text class="t-b" [attr.x]="n.x + 10" [attr.y]="n.y + 17">{{ n.listener ? '🖥 ' : '' }}{{ n.title }}</text>
                <text class="t-sub t-mono" [attr.x]="n.x + 10" [attr.y]="n.y + 31">{{ n.ip }}</text>
                <text class="t-sub" [attr.x]="n.x + 10" [attr.y]="n.y + 44">{{ n.sub }}</text>
              </g>
              <!-- KNXnet/IP routing (multicast) = backbone -->
              <g class="knxt-band">
                <rect [attr.x]="svg.band.x" [attr.y]="svg.band.y" [attr.width]="svg.band.w" [attr.height]="svg.band.h" rx="5"></rect>
                <text [attr.x]="svg.band.x + 10" [attr.y]="svg.band.y + 15">{{ svg.band.label }}</text>
              </g>
              <!-- One column per line: coupler header + TP line with its devices -->
              <g *ngFor="let c of svg.cols; trackBy: trackCol">
                <g class="knxt-head" [class.backbone]="c.l.backbone">
                  <title>{{ c.tip }}</title>
                  <rect [attr.x]="c.x" [attr.y]="c.y" [attr.width]="c.w" [attr.height]="c.h" rx="7"></rect>
                  <text class="t-b" [attr.x]="c.x + 10" [attr.y]="c.y + 17">{{ c.l1 }}</text>
                  <text class="t-sub t-mono" [attr.x]="c.x + 10" [attr.y]="c.y + 32">{{ c.l2 }}</text>
                  <text class="t-sub" [attr.x]="c.x + 10" [attr.y]="c.y + 46">{{ c.l3 }}</text>
                </g>
                <g *ngFor="let d of c.devs; trackBy: trackDev" class="knxt-d" [ngClass]="'knxr-' + d.v.role"
                   [class.sel]="selectedIa === d.v.ia" [class.dim]="topoMatch && !topoMatch.has(d.v.ia)" [class.silent]="d.v.silent"
                   tabindex="0" role="button" [attr.aria-label]="d.v.ia + ' ' + d.v.roleLabel + (d.v.ident ? ', ' + d.v.ident.product : '')"
                   [attr.transform]="'translate(' + d.x + ',' + d.y + ')'"
                   (click)="selectDevice(d.v.ia)" (keydown.enter)="selectDevice(d.v.ia)"
                   (keydown.space)="selectDevice(d.v.ia); $event.preventDefault()">
                  <title>{{ d.tip }}</title>
                  <rect class="bg" [attr.width]="d.w" [attr.height]="d.h" rx="5"></rect>
                  <rect class="tint" [attr.width]="d.w" [attr.height]="d.h" rx="5"></rect>
                  <rect class="bar" x="0" y="0" width="5" [attr.height]="d.h" rx="2"></rect>
                  <text class="t-b t-mono" x="12" y="15">{{ d.v.ia }}</text>
                  <text class="t-sub t-end" [attr.x]="d.w - 8" y="15">{{ d.conf }}</text>
                  <text *ngIf="d.prod" class="t-prod" x="12" y="29">{{ d.prod }}</text>
                  <text class="t-sub" x="12" [attr.y]="d.roleY">{{ d.role }}</text>
                </g>
              </g>
            </svg>
          </div>
          <div *ngIf="topoLegend.length" class="knxt-legend mt-2">
            <span *ngFor="let r of topoLegend; trackBy: trackRole" [ngClass]="'knxr-' + r.role"><span class="knxt-dot" [class.knxt-dot-silent]="r.role === 'silent'"></span>{{ r.label }}</span>
            <span *ngIf="svg.ids">{{ 'ADMIN_KNX_TOPO_LEGEND_PRODUCT' | translate }}</span>
          </div>
          <!-- Device picked in the diagram -->
          <div *ngIf="selectedCard as v" #topoSelCard class="knxt-line mt-2">
            <div class="d-flex align-items-center gap-2 px-2 py-1" style="background:var(--bs-tertiary-bg);">
              <span class="knxm-card-title me-auto">{{ v.ia }} · {{ 'ADMIN_KNX_TOPO_DETAILS' | translate }}</span>
              <button type="button" class="btn btn-sm btn-outline-secondary knxt-close m-touch-sm" (click)="closeSelection()"
                      [title]="'ADMIN_KNX_TOPO_CLOSE' | translate" [attr.aria-label]="'ADMIN_KNX_TOPO_CLOSE' | translate">×</button>
            </div>
            <ng-container *ngTemplateOutlet="topoDevice; context: { $implicit: v, detail: true }"></ng-container>
          </div>
        </div>
      </div>

      <!-- b) Devices per line -->
      <div *ngIf="topoDeviceCount" class="mb-3">
        <div class="knxm-card-title mb-1">{{ 'ADMIN_KNX_TOPO_DEVICES' | translate }}</div>
        <div *ngIf="!topoListView.length" class="text-muted small py-2">{{ 'ADMIN_KNX_NO_MATCH' | translate }}</div>
        <div *ngFor="let x of topoListView; trackBy: trackLine" class="knxt-line">
          <button type="button" class="knxt-line-head" (click)="toggleLine(x.l.line)" [attr.aria-expanded]="!collapsedLines[x.l.line]">
            <span class="knxt-chev">{{ collapsedLines[x.l.line] ? '▸' : '▾' }}</span>
            <span class="fw-semibold">{{ x.l.title }}</span>
            <span class="knxm-sub mono" [title]="x.l.gwTitle">{{ x.l.gwText }}</span>
            <span class="knxm-stats ms-auto">{{ x.l.devCount }}<ng-container *ngIf="x.l.silentText"> ({{ x.l.silentText }})</ng-container><ng-container *ngIf="x.l.rate"> · {{ x.l.rate }}</ng-container><ng-container *ngIf="x.l.scanned"> · {{ 'ADMIN_KNX_TOPO_SCANNED' | translate:{ date: x.l.scanned } }}</ng-container></span>
          </button>
          <ng-container *ngIf="!collapsedLines[x.l.line]">
            <ng-container *ngFor="let v of x.devices; trackBy: trackDev">
              <ng-container *ngTemplateOutlet="topoDevice; context: { $implicit: v, detail: false }"></ng-container>
            </ng-container>
          </ng-container>
        </div>
      </div>

      <!-- c) Inventory from the read-only line scan (manufacturer / product per device, CSV built in the browser) -->
      <div *ngIf="invLoaded || invError" class="mb-3">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
          <button type="button" class="knxi-toggle" (click)="toggleInventory()" [attr.aria-expanded]="invOpen">
            <span class="knxt-chev">{{ invOpen ? '▾' : '▸' }}</span><span class="knxm-card-title">{{ 'ADMIN_KNX_INV_TITLE' | translate }}</span>
          </button>
          <span class="knxi-counts me-auto">
            <span *ngIf="invTotal">{{ 'ADMIN_KNX_SHOWN' | translate:{ shown: invShown, total: invTotal } }}</span>
            <ng-container *ngFor="let c of identConfs"><span *ngIf="invCounts[c]" class="badge knxi-c" [ngClass]="'knxi-c-' + c">{{ invCounts[c] }} {{ ('ADMIN_KNX_ID_CONF_' + (c | uppercase)) | translate }}</span></ng-container>
            <span *ngIf="invCounts.silent" class="badge knxi-c knxi-c-silent" [title]="'ADMIN_KNX_INV_SILENT_HINT' | translate">{{ invCounts.silent }} {{ 'ADMIN_KNX_INV_SILENT' | translate }}</span>
          </span>
          <button type="button" class="btn btn-sm btn-outline-primary text-nowrap knxm-btn-xs"
                  [disabled]="!invTotal" (click)="downloadInventoryCsv()">⬇ {{ 'ADMIN_KNX_INV_CSV' | translate }}</button>
        </div>
        <div class="knxm-hint mb-2">{{ 'ADMIN_KNX_INV_HINT' | translate }}</div>
        <!-- Scan files the backend could not use (unreadable, too large, skipped entries) -->
        <div *ngIf="invWarnings.length" class="text-warning-emphasis knxm-sub knxi-warn mb-2" role="status">
          <div class="fw-semibold">⚠ {{ 'ADMIN_KNX_INV_WARNINGS' | translate:{ n: invWarnings.length + invWarningsMore } }}</div>
          <div *ngFor="let w of invWarnings" class="mono">{{ w }}</div>
          <div *ngIf="invWarningsMore">{{ 'ADMIN_KNX_INV_WARNINGS_MORE' | translate:{ n: invWarningsMore } }}</div>
        </div>
        <div *ngIf="invError" class="alert alert-danger py-1 px-2 small mb-2">{{ 'ADMIN_KNX_INV_ERROR' | translate:{ msg: invError } }}</div>
        <div *ngIf="invOpen && invLoaded && !invTotal" class="text-muted small py-2">
          {{ 'ADMIN_KNX_INV_EMPTY' | translate }}<span *ngIf="invDirs" class="mono"> {{ 'ADMIN_KNX_INV_DIRS' | translate:{ dirs: invDirs } }}</span>
        </div>
        <div *ngIf="invOpen && invTotal && !invView.length" class="text-muted small py-2">{{ 'ADMIN_KNX_NO_MATCH' | translate }}</div>
        <div *ngIf="invOpen && invView.length" class="knxt-tbl-wrap">
          <table class="table table-sm knxt-tbl knxi-tbl mb-0">
            <thead>
              <tr>
                <th>{{ 'ADMIN_KNX_INV_COL_IA' | translate }}</th>
                <th class="d-none d-md-table-cell">{{ 'ADMIN_KNX_ID_MANUFACTURER' | translate }}</th>
                <th>{{ 'ADMIN_KNX_ID_PRODUCT' | translate }}</th>
                <th class="d-none d-md-table-cell">{{ 'ADMIN_KNX_ID_TYPE' | translate }}</th>
                <th>{{ 'ADMIN_KNX_ID_CONF' | translate }}</th>
                <th>{{ 'ADMIN_KNX_INV_COL_BUS' | translate }}</th>
              </tr>
            </thead>
            <tbody *ngFor="let l of invView; trackBy: trackInv">
              <tr class="knxi-line">
                <td colspan="6">
                  <span class="fw-semibold me-2">{{ l.title }}</span><span class="knxm-sub" [title]="l.file">{{ l.meta }}</span>
                  <div *ngIf="l.warn" class="text-warning-emphasis knxm-sub">⚠ {{ l.warn }}</div>
                  <div *ngIf="l.conOnly" class="knxm-sub">{{ l.conOnly }}</div>
                </td>
              </tr>
              <tr *ngFor="let r of l.rows; trackBy: trackInv" [class.knxi-silent]="r.bus === 'silent'">
                <td class="mono nowrap">{{ r.ia }}</td>
                <td class="d-none d-md-table-cell">{{ r.ident?.mfr || '–' }}</td>
                <td class="knxi-prod-cell">
                  <ng-container *ngIf="r.ident as id; else noIdent">
                    <div class="knxm-sub d-md-none">{{ id.mfr }}</div>
                    <span [class.knxi-unknown]="!id.known" [title]="id.product">{{ id.bare }}</span>
                    <div *ngIf="id.type" class="knxm-sub d-md-none">{{ id.type }}</div>
                  </ng-container>
                  <ng-template #noIdent><span class="knxi-unknown">{{ r.noIdent }}</span></ng-template>
                </td>
                <td class="d-none d-md-table-cell">{{ r.ident?.type || '' }}</td>
                <td class="nowrap"><span *ngIf="r.ident as id" class="badge knxi-c" [ngClass]="'knxi-c-' + id.conf">{{ id.confLabel }}</span></td>
                <td class="nowrap knxi-bus" [title]="r.busTitle">{{ r.busLabel }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- d) Name suggestions -->
      <div class="mb-2">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-1">
          <span class="knxm-card-title me-auto">{{ 'ADMIN_KNX_TOPO_SUGGESTIONS' | translate }}</span>
          <select class="form-select form-select-sm knxm-sel knxm-sug-sel" [(ngModel)]="sugFilter" (ngModelChange)="sugFilterChanged()"
                  [attr.aria-label]="'ADMIN_KNX_TOPO_SUGGESTIONS' | translate">
            <option value="">{{ 'ADMIN_KNX_SUG_ALL' | translate }} ({{ sugTotal }})</option>
            <option value="accepted">{{ 'ADMIN_KNX_SUG_STATUS_ACCEPTED' | translate }} ({{ sugCounts.accepted }})</option>
            <option value="candidate">{{ 'ADMIN_KNX_SUG_STATUS_CANDIDATE' | translate }} ({{ sugCounts.candidate }})</option>
            <option value="hint">{{ 'ADMIN_KNX_SUG_STATUS_HINT' | translate }} ({{ sugCounts.hint }})</option>
            <option value="book">{{ 'ADMIN_KNX_SUG_IN_BOOK' | translate }} ({{ sugCounts.book }})</option>
          </select>
          <button type="button" class="btn btn-sm btn-outline-primary text-nowrap knxm-btn-xs"
                  [disabled]="csvDownloading" (click)="downloadSuggestionsCsv()">
            <span *ngIf="csvDownloading" class="spinner-border spinner-border-sm me-1" style="width:.7rem;height:.7rem;"></span>⬇ {{ 'ADMIN_KNX_SUG_CSV' | translate }}
          </button>
        </div>
        <div class="knxm-hint mb-2">{{ 'ADMIN_KNX_SUG_CSV_HINT' | translate }}</div>
        <div *ngIf="csvError" class="alert alert-danger py-1 px-2 small mb-2">{{ 'ADMIN_KNX_ERROR' | translate:{ msg: csvError } }}</div>
        <div *ngIf="sugError" class="alert alert-danger py-1 px-2 small mb-2">{{ 'ADMIN_KNX_ERROR' | translate:{ msg: sugError } }}</div>
        <div *ngIf="sugView.length" class="knxt-tbl-wrap">
          <table class="table table-sm knxt-tbl knxt-sug mb-0">
            <thead>
              <tr>
                <th>{{ 'ADMIN_KNX_COL_GA' | translate }}</th>
                <th>{{ 'ADMIN_KNX_SUG_COL_SUGGESTION' | translate }}</th>
                <th>{{ 'ADMIN_KNX_SUG_COL_STATUS' | translate }}</th>
                <th>{{ 'ADMIN_KNX_SUG_COL_EVIDENCE' | translate }}</th>
                <th>DPT</th>
                <th>{{ 'ADMIN_KNX_COL_SOURCES' | translate }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of sugView; trackBy: trackSug" [class.knxt-sug-book]="r.bookName && !(r.differs && r.status === 'accepted')">
                <td class="mono nowrap c-ga">{{ r.s.ga }}</td>
                <td class="knxm-name c-name">
                  <ng-container *ngIf="!r.bookName">{{ r.name || '–' }}</ng-container>
                  <ng-container *ngIf="r.bookName">
                    {{ r.bookName }}<span class="badge knxt-book" [title]="'ADMIN_KNX_SUG_IN_BOOK_HINT' | translate">{{ 'ADMIN_KNX_SUG_IN_BOOK' | translate }}</span>
                    <div *ngIf="r.differs" class="knxm-sub">
                      <span *ngIf="r.status === 'accepted'" class="badge knxt-differs" [title]="'ADMIN_KNX_SUG_DIFFERS_HINT' | translate">{{ 'ADMIN_KNX_SUG_DIFFERS' | translate }}</span>
                      <span class="knxm-sugg">{{ 'ADMIN_KNX_SUG_LEARNED' | translate }}: {{ r.suggested }}</span>
                    </div>
                  </ng-container>
                </td>
                <td class="nowrap c-st">
                  <span class="badge knxt-st" [ngClass]="'knxt-st-' + r.status">{{ ('ADMIN_KNX_SUG_STATUS_' + (r.status | uppercase)) | translate }}</span>
                  <div *ngIf="r.conf !== null" class="knxt-conf knxt-sug-conf mt-1" [ngClass]="'knxt-c-' + r.status"><span class="knxm-bar-bg"><span [style.width.%]="r.conf"></span></span>{{ r.conf }} %</div>
                </td>
                <td class="c-ev">
                  <span *ngIf="r.hits" class="fw-semibold me-1">{{ r.hits }}</span><span class="text-body-secondary">{{ r.evidence }}</span>
                  <div *ngIf="r.candidates" class="knxm-sub">{{ 'ADMIN_KNX_SUG_CANDIDATES' | translate }}: {{ r.candidates }}</div>
                </td>
                <td class="nowrap c-dpt">
                  <span *ngIf="r.dptLabel" class="badge knxm-dpt" [ngClass]="r.s.dptGuessed ? 'knxm-dpt-guess' : 'knxm-dpt-book'"
                        [title]="r.s.dptGuessed ? guessedTitle : 'DPT ' + r.s.dpt">{{ r.dptLabel }}</span>
                </td>
                <td class="mono knxm-sub knxm-srcs c-srcs"><span *ngIf="r.senders" class="knxm-lbl">{{ lbl.sources }}</span>{{ r.senders }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div *ngIf="!sugView.length && !sugError" class="text-muted small py-2">
          {{ (!sugLoaded ? 'ADMIN_KNX_LOADING' : sugTotal ? 'ADMIN_KNX_NO_MATCH' : 'ADMIN_KNX_SUG_NONE') | translate }}
        </div>
      </div>
    </div>
  </div>

  <!-- ═══ Ventile: valve positions (main group 16) and the learned valve ↔ room mapping ═══ -->
  <div *ngSwitchCase="'valves'" class="knxm-pane">
    <app-admin-knx-valves [authHeaders]="authHeaders" (unauthorized)="unauthorized.emit()"></app-admin-knx-valves>
  </div>

  <!-- ═══ Gruppenadressen ═══ -->
  <div *ngSwitchCase="'groups'" class="knxm-pane">
    <div class="knxm-bar px-2 px-sm-3 py-2 border-bottom flex-shrink-0">
      <input type="search" class="form-control form-control-sm knxm-q"
             [(ngModel)]="groupQ" (ngModelChange)="groupFilterChanged()"
             [placeholder]="'ADMIN_KNX_GROUP_FILTER' | translate">
      <span class="knxm-stats me-auto">{{ 'ADMIN_KNX_SHOWN' | translate:{ shown: groupView.length, total: groupsCount } }}</span>
      <button type="button" class="btn btn-sm btn-outline-secondary m-touch-sm" (click)="refreshGroups()"
              [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
      <div class="btn-group btn-group-sm dash-seg knxm-sort" role="group">
        <button *ngFor="let s of groupSorts" type="button" class="btn" [attr.aria-pressed]="groupSort === s.key"
                [ngClass]="groupSort === s.key ? 'btn-secondary' : 'btn-outline-secondary'"
                (click)="sortGroups(s.key)">{{ s.label | translate }}{{ sortMark(s.key) }}</button>
      </div>
    </div>
    <div *ngIf="groupsError" class="alert alert-danger py-1 px-2 m-2 mb-0 small flex-shrink-0">{{ 'ADMIN_KNX_ERROR' | translate:{ msg: groupsError } }}</div>
    <div class="knxm-scroll">
      <table *ngIf="groupView.length" class="table table-sm table-hover mb-0 knxm-table knxm-grp">
        <thead>
          <tr>
            <th class="knxm-sortable" (click)="sortGroups('ga')">{{ 'ADMIN_KNX_COL_GA' | translate }}{{ sortMark('ga') }}</th>
            <th>{{ 'ADMIN_KNX_COL_NAME' | translate }}</th>
            <th>DPT</th>
            <th class="knxm-sortable text-end" (click)="sortGroups('count')">{{ 'ADMIN_KNX_COL_COUNT' | translate }}{{ sortMark('count') }}</th>
            <th>{{ 'ADMIN_KNX_COL_LAST_VALUE' | translate }}</th>
            <th class="knxm-sortable" (click)="sortGroups('last')">{{ 'ADMIN_KNX_COL_LAST_SEEN' | translate }}{{ sortMark('last') }}</th>
            <th>{{ 'ADMIN_KNX_COL_SOURCES' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let r of groupView; trackBy: trackGroup" style="cursor:default;">
            <td class="mono nowrap c-ga">{{ r.g.dst }}</td>
            <td class="c-name">
              <div *ngIf="!r.sug" class="knxm-name">{{ r.g.name || '–' }}</div>
              <div *ngIf="r.sug" class="knxm-name" [title]="sugTitle"><span class="knxm-sugg">~ {{ r.g.suggestedName }}</span><span class="badge knxm-sugg-badge">{{ sugBadge[r.sug] }}</span></div>
              <div *ngIf="r.g.group" class="knxm-sub">{{ r.g.group }}</div>
            </td>
            <td class="nowrap c-dpt">
              <span *ngIf="r.dptLabel" class="badge knxm-dpt" [ngClass]="r.g.dptGuessed ? 'knxm-dpt-guess' : 'knxm-dpt-book'"
                    [title]="r.g.dptGuessed ? guessedTitle : 'DPT ' + r.g.dpt">{{ r.dptLabel }}</span>
            </td>
            <td class="knxm-num c-count"><span class="knxm-lbl">{{ lbl.count }}</span>{{ fmtNum(r.g.count) }}</td>
            <td class="c-last" [title]="r.g.lastApci || ''">{{ r.lastText || '–' }}</td>
            <td class="nowrap c-seen" [title]="r.lastFull">{{ r.g.lastSeen ? ('UPDATED_AGO' | translate:{ time: r.ago }) : '–' }}</td>
            <td class="mono knxm-sub knxm-srcs c-srcs"><span *ngIf="r.sources" class="knxm-lbl">{{ lbl.sources }}</span>{{ r.sources }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="!groupView.length" class="text-muted small text-center py-4 px-3">
        {{ (!groupsLoaded ? 'ADMIN_KNX_LOADING' : groupsCount ? 'ADMIN_KNX_NO_MATCH' : 'ADMIN_KNX_NO_GROUPS') | translate }}
      </div>
    </div>
  </div>

  <!-- ═══ Verlauf ═══ -->
  <div *ngSwitchCase="'history'" class="knxm-pane knxm-hist">
    <form class="px-2 px-sm-3 py-2 border-bottom flex-shrink-0" (ngSubmit)="searchHistory()">
      <div class="row g-2 align-items-end">
        <div class="col-12 col-sm-6 col-md-auto">
          <label class="form-label knxm-hint mb-0" for="knxmFrom">{{ 'ADMIN_KNX_FROM' | translate }}</label>
          <input id="knxmFrom" name="from" type="datetime-local" class="form-control form-control-sm" [(ngModel)]="histFrom" (ngModelChange)="histRangeEdited()">
        </div>
        <div class="col-12 col-sm-6 col-md-auto">
          <label class="form-label knxm-hint mb-0" for="knxmTo">{{ 'ADMIN_KNX_TO' | translate }}</label>
          <input id="knxmTo" name="to" type="datetime-local" class="form-control form-control-sm" [(ngModel)]="histTo" (ngModelChange)="histRangeEdited()">
        </div>
        <div class="col col-sm-auto">
          <div class="btn-group btn-group-sm dash-seg" role="group">
            <button type="button" class="btn btn-outline-primary" (click)="setRange(3600000)">1 h</button>
            <button type="button" class="btn btn-outline-primary" (click)="setRange(86400000)">24 h</button>
            <button type="button" class="btn btn-outline-primary" (click)="setRange(7 * 86400000)">{{ 'ADMIN_KNX_7D' | translate }}</button>
          </div>
        </div>
        <div class="col-auto">
          <select class="form-select form-select-sm" name="limit" [(ngModel)]="histLimit" [title]="'ADMIN_KNX_LIMIT' | translate">
            <option *ngFor="let l of histLimits" [ngValue]="l">max. {{ l }}</option>
          </select>
        </div>
        <div class="w-100 d-none d-md-block m-0"></div>
        <div class="col-12 col-md">
          <input name="q" type="search" class="form-control form-control-sm" [(ngModel)]="histQ" [placeholder]="'ADMIN_KNX_TEXT' | translate">
        </div>
        <div class="col-6 col-md-2">
          <input name="ga" type="search" class="form-control form-control-sm mono" [(ngModel)]="histGa" placeholder="GA 16/4/" [title]="'ADMIN_KNX_GA_PREFIX' | translate">
        </div>
        <div class="col-6 col-md-2">
          <input name="src" type="search" class="form-control form-control-sm mono" [(ngModel)]="histSrc" [placeholder]="'ADMIN_KNX_SRC_PLACEHOLDER' | translate" [title]="'ADMIN_KNX_SRC_PREFIX' | translate">
        </div>
        <div class="col-6 col-md-2">
          <select name="apci" class="form-select form-select-sm" [(ngModel)]="histApci">
            <option value="">{{ 'ADMIN_KNX_ALL_APCI' | translate }}</option>
            <option *ngFor="let a of apciOptions" [value]="a">{{ a }}</option>
          </select>
        </div>
        <div class="col-6 col-md-auto">
          <button type="submit" class="btn btn-sm btn-primary w-100" [disabled]="histLoading">
            <span *ngIf="histLoading" class="spinner-border spinner-border-sm me-1" role="status"></span>{{ 'ADMIN_KNX_SEARCH' | translate }}
          </button>
        </div>
      </div>
    </form>
    <div *ngIf="histSearched" class="d-flex align-items-center gap-2 px-2 px-sm-3 py-1 border-bottom flex-shrink-0">
      <span class="knxm-stats me-auto text-truncate" [title]="histFiles.join(', ')">
        {{ 'ADMIN_KNX_RESULTS' | translate:{ n: histView.length } }} · {{ histFiles.length }} {{ 'ADMIN_KNX_FILES' | translate }}
      </span>
      <button type="button" class="btn btn-sm btn-link text-decoration-none p-0 knxm-order" (click)="toggleHistOrder()">
        {{ (histNewestFirst ? 'ADMIN_KNX_NEWEST_FIRST' : 'ADMIN_KNX_OLDEST_FIRST') | translate }}
      </button>
    </div>
    <div *ngIf="histError" class="alert alert-danger py-1 px-2 m-2 mb-0 small flex-shrink-0">{{ histError }}</div>
    <div *ngIf="histTruncated" class="alert alert-warning py-1 px-2 m-2 mb-0 small flex-shrink-0">⚠ {{ 'ADMIN_KNX_TRUNCATED' | translate:{ n: histUsedLimit } }}</div>
    <div class="knxm-scroll">
      <ng-container *ngIf="histView.length">
        <ng-container *ngTemplateOutlet="telegramTable; context: { $implicit: histView, withDate: true }"></ng-container>
      </ng-container>
      <div *ngIf="histSearched && !histView.length && !histLoading" class="text-muted small text-center py-4 px-3">{{ 'ADMIN_KNX_NO_RESULTS' | translate }}</div>
      <div *ngIf="!histSearched && !histLoading" class="text-muted small text-center py-4 px-3">{{ 'ADMIN_KNX_HISTORY_HINT' | translate }}</div>
    </div>
  </div>

  <!-- ═══ Status ═══ -->
  <div *ngSwitchCase="'status'" class="knxm-pane">
    <div class="knxm-scroll p-2 p-sm-3">
      <div class="d-flex align-items-center gap-2 mb-2">
        <span class="knxm-hint me-auto">🔒 {{ 'ADMIN_KNX_PASSIVE' | translate }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary m-touch-sm" (click)="refreshStatus()"
                [title]="'AKTUALISIEREN' | translate" [attr.aria-label]="'AKTUALISIEREN' | translate">↻</button>
      </div>
      <div *ngIf="statusError" class="alert alert-danger py-1 px-2 small">{{ 'ADMIN_KNX_ERROR' | translate:{ msg: statusError } }}</div>
      <div *ngIf="!status && !statusError" class="text-muted small text-center py-4">{{ 'ADMIN_KNX_LOADING' | translate }}</div>

      <div *ngIf="status as v" class="row g-2">

        <!-- Listener -->
        <div class="col-12 col-lg-6">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3 knxm-small">
              <div class="d-flex align-items-center gap-2 mb-2">
                <span class="knxm-card-title me-auto">{{ 'ADMIN_KNX_LISTENER' | translate }}</span>
                <span class="badge" [ngClass]="v.s.listening ? 'text-bg-success' : 'text-bg-danger'">
                  {{ (v.s.listening ? 'ADMIN_KNX_LISTENING' : 'ADMIN_KNX_NOT_LISTENING') | translate }}
                </span>
              </div>
              <div class="knxm-kv">
                <span class="text-muted">{{ 'ADMIN_KNX_IFACE' | translate }}</span><span class="mono">{{ v.s.iface || '–' }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_LOCAL_IP' | translate }}</span><span class="mono">{{ v.s.localIp || '–' }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_SUBNET' | translate }}</span><span class="mono">{{ v.s.subnet || '–' }}</span>
                <span class="text-muted">Multicast</span><span class="mono">{{ v.s.group || '–' }}:{{ v.s.port || '–' }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_STARTED' | translate }}</span><span>{{ v.started }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_TOTAL_COUNT' | translate }}</span><span class="fw-semibold">{{ fmtNum(v.s.total) }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_RATE' | translate }}</span><span class="fw-semibold">{{ fmtNum(v.s.ratePerMin) }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_LAST_TELEGRAM' | translate }}</span>
                <span [title]="v.lastTelegramFull">{{ v.lastTelegramAgo ? ('UPDATED_AGO' | translate:{ time: v.lastTelegramAgo }) : '–' }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_LOST' | translate }}</span><span [class.text-danger]="v.s.lost">{{ fmtNum(v.s.lost ?? 0) }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_BUSY' | translate }}</span><span [class.text-danger]="v.s.busy">{{ fmtNum(v.s.busy ?? 0) }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_DROPPED' | translate }}</span><span [class.text-danger]="v.s.dropped">{{ fmtNum(v.s.dropped ?? 0) }}</span>
              </div>
              <div *ngIf="v.s.lastError" class="mt-2 small text-danger-emphasis" style="word-break:break-word;">
                <span class="fw-semibold">{{ 'ADMIN_KNX_LAST_ERROR' | translate }}<span *ngIf="v.lastErrorAt"> ({{ v.lastErrorAt }})</span>:</span> {{ v.s.lastError }}
              </div>
            </div>
          </div>
        </div>

        <!-- Gateways + APCIs -->
        <div class="col-12 col-lg-6">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3 knxm-small">
              <div class="knxm-card-title mb-1">{{ 'ADMIN_KNX_PER_GATEWAY' | translate }}</div>
              <table class="table table-sm table-borderless mb-2" style="font-size:.75rem;">
                <tbody>
                  <tr *ngFor="let g of v.gateways; trackBy: trackKey">
                    <td class="mono nowrap ps-0">{{ g.key }}</td>
                    <td class="w-100 align-middle"><div class="knxm-bar-bg"><span [style.width.%]="g.pct"></span></div></td>
                    <td class="knxm-num pe-0">{{ fmtNum(g.count) }}</td>
                  </tr>
                  <tr *ngIf="!v.gateways.length"><td class="text-muted ps-0">–</td></tr>
                </tbody>
              </table>
              <div class="knxm-card-title mb-1">{{ 'ADMIN_KNX_PER_APCI' | translate }}</div>
              <table class="table table-sm table-borderless mb-0" style="font-size:.75rem;">
                <tbody>
                  <tr *ngFor="let a of v.apcis; trackBy: trackKey">
                    <td class="nowrap ps-0">{{ a.key }}</td>
                    <td class="w-100 align-middle"><div class="knxm-bar-bg"><span [style.width.%]="a.pct"></span></div></td>
                    <td class="knxm-num pe-0">{{ fmtNum(a.count) }}</td>
                  </tr>
                  <tr *ngIf="!v.apcis.length"><td class="text-muted ps-0">–</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <!-- Log files -->
        <div class="col-12 col-lg-6">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3 knxm-small">
              <div class="knxm-card-title mb-1">{{ 'ADMIN_KNX_LOG_FILES' | translate }}</div>
              <div class="knxm-hint mb-2">
                <span class="mono">{{ v.s.logDir || '–' }}</span>
                <span *ngIf="v.s.retentionDays"> · {{ 'ADMIN_KNX_RETENTION' | translate:{ n: v.s.retentionDays } }}</span>
              </div>
              <div *ngIf="downloadError" class="alert alert-danger py-1 px-2 small mb-2">{{ downloadError }}</div>
              <div *ngIf="!v.files.length" class="text-muted small">{{ 'ADMIN_KNX_NO_FILES' | translate }}</div>
              <div *ngFor="let f of v.files; trackBy: trackFile" class="d-flex align-items-center gap-2 py-1 border-top">
                <span class="mono">{{ f.date }}</span>
                <span class="text-muted ms-auto knxm-num">{{ f.size }}</span>
                <button type="button" class="btn btn-sm btn-outline-primary py-0 knxm-btn-xs knxm-dl"
                        [disabled]="downloading" (click)="download(f.date)">
                  <span *ngIf="downloading === f.date" class="spinner-border spinner-border-sm me-1" style="width:.7rem;height:.7rem;"></span>⬇ {{ 'ADMIN_KNX_DOWNLOAD' | translate }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- GA book -->
        <div class="col-12 col-lg-6">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3 knxm-small">
              <div class="knxm-card-title mb-1">{{ 'ADMIN_KNX_GA_BOOK' | translate }}</div>
              <div *ngIf="!v.s.gaBook?.entries" class="knxm-hint mb-2">{{ 'ADMIN_KNX_GA_NONE' | translate }}</div>
              <div class="knxm-kv mb-2">
                <span class="text-muted">{{ 'ADMIN_KNX_GA_ENTRIES' | translate }}</span><span class="fw-semibold">{{ fmtNum(v.s.gaBook?.entries ?? 0) }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_GA_LOADED' | translate }}</span><span>{{ v.gaLoaded }}</span>
                <span class="text-muted">{{ 'ADMIN_KNX_GA_FILE' | translate }}</span><span class="mono" style="word-break:break-all;">{{ v.s.gaBook?.file || '–' }}</span>
              </div>
              <details *ngIf="v.gaWarnings.length" class="mb-2">
                <summary class="small text-warning-emphasis">{{ 'ADMIN_KNX_WARNINGS' | translate }} ({{ v.gaWarnings.length }})</summary>
                <ul class="knxm-hint mb-0 ps-3 mt-1" style="max-height:8rem;overflow:auto;">
                  <li *ngFor="let w of v.gaWarnings">{{ w }}</li>
                </ul>
              </details>
              <div class="knxm-hint mb-1">{{ 'ADMIN_KNX_GA_UPLOAD_HINT' | translate }}</div>
              <div class="input-group input-group-sm">
                <input #gaInput type="file" class="form-control" accept=".csv,.txt,text/csv,text/plain" (change)="onGaFile($event)">
                <button type="button" class="btn btn-primary" [disabled]="!gaFile || gaUploading" (click)="uploadGa(gaInput)">
                  <span *ngIf="gaUploading" class="spinner-border spinner-border-sm me-1"></span>{{ 'ADMIN_KNX_GA_UPLOAD' | translate }}
                </button>
              </div>
              <div *ngIf="gaError" class="alert alert-danger py-1 px-2 small mt-2 mb-0">{{ gaError }}</div>
              <div *ngIf="gaResult as res" class="alert alert-success py-1 px-2 small mt-2 mb-0">
                ✓ {{ res.entries != null ? ('ADMIN_KNX_GA_UPLOADED' | translate:{ entries: res.entries, mains: res.mains ?? 0, middles: res.middles ?? 0 })
                                         : ('ADMIN_KNX_GA_SAVED' | translate) }}
                <ul *ngIf="res.warnings?.length" class="mb-0 ps-3 mt-1" style="max-height:8rem;overflow:auto;">
                  <li *ngFor="let w of res.warnings">{{ w }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>

</ng-container>

<!-- Shared bus monitor table (Live + Verlauf); click a row for the frame details -->
<ng-template #telegramTable let-rows let-withDate="withDate">
  <table *ngIf="rows.length" class="table table-sm table-hover mb-0 knxm-table knxm-tg">
    <thead>
      <tr>
        <th>{{ 'ADMIN_KNX_COL_TIME' | translate }}</th>
        <th>{{ 'ADMIN_KNX_COL_LINE' | translate }}</th>
        <th>{{ 'ADMIN_KNX_COL_SRC' | translate }}</th>
        <th>{{ 'ADMIN_KNX_COL_DST' | translate }}</th>
        <th>{{ 'ADMIN_KNX_COL_APCI' | translate }}</th>
        <th>{{ 'ADMIN_KNX_COL_DATA' | translate }}</th>
        <th>{{ 'ADMIN_KNX_COL_VALUE' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let r of rows; trackBy: trackRow">
        <tr [class.knxm-err]="r.t.error" [class.table-active]="expanded === r.uid" (click)="toggleRow(r)">
          <td class="mono nowrap c-time"><div *ngIf="withDate" class="knxm-sub">{{ r.day }}</div>{{ r.time }}</td>
          <td class="mono nowrap c-line">{{ r.line || '–' }}<div class="knxm-sub">{{ r.t.gw }}</div></td>
          <td class="mono nowrap c-src">{{ r.t.src || '–' }}</td>
          <td class="c-dst">
            <span class="mono nowrap">{{ r.t.dst || '–' }}</span>
            <div *ngIf="r.t.name" class="knxm-name">{{ r.t.name }}</div>
            <div *ngIf="r.sug" class="knxm-name" [title]="sugTitle"><span class="knxm-sugg">~ {{ r.t.suggestedName }}</span><span class="badge knxm-sugg-badge">{{ sugBadge[r.sug] }}</span></div>
            <div *ngIf="r.t.group" class="knxm-sub">{{ r.t.group }}</div>
          </td>
          <td class="c-apci"><span class="badge knxm-apci" [ngClass]="r.apciCls" [title]="r.t.apci || r.t.service || ''">{{ r.apciLabel }}</span></td>
          <td class="mono knxm-data c-data" [title]="r.data">{{ r.data }}</td>
          <td class="knxm-val c-val">
            <span *ngIf="r.dptLabel" class="badge knxm-dpt" [ngClass]="r.t.dptGuessed ? 'knxm-dpt-guess' : 'knxm-dpt-book'"
                  [title]="r.t.dptGuessed ? guessedTitle : 'DPT ' + r.t.dpt">{{ r.dptLabel }}</span>{{ r.t.text }}
            <div *ngIf="r.t.error" class="text-danger-emphasis knxm-err-text">⚠ {{ r.t.error }}</div>
          </td>
        </tr>
        <tr *ngIf="expanded === r.uid" class="knxm-detail">
          <td colspan="7" (click)="$event.stopPropagation()">
            <div class="knxm-kv">
              <span class="text-muted">seq</span><span class="mono">{{ r.t.seq }} · {{ r.t.service || '–' }} · {{ r.t.msg || '–' }}</span>
              <span class="text-muted">ctrl</span>
              <span class="mono">prio {{ r.t.prio || '–' }} · hops {{ r.t.hops ?? '–' }} · repeat {{ r.t.repeat ?? '–' }} · {{ r.t.dstType || '–' }} · {{ r.t.tpci || '–' }} · {{ r.t.apci || '–' }}</span>
              <ng-container *ngIf="r.t.dpt">
                <span class="text-muted">DPT</span>
                <span class="mono">{{ r.t.dpt }}{{ r.t.dptGuessed ? ' (~)' : '' }} · value {{ valueJson(r.t.value) }}{{ r.t.unit ? ' ' + r.t.unit : '' }}</span>
              </ng-container>
              <span class="text-muted">raw</span><span class="mono">{{ spacedHex(r.t.raw) }}</span>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>
</ng-template>

<!-- Learned device: entry of the device list, and the detail card under the diagram -->
<ng-template #topoDevice let-v let-detail="detail">
  <div class="knxt-dev" [ngClass]="'knxr-' + v.role" [class.sel]="!detail && selectedIa === v.ia">
    <div class="knxt-dev-head" [class.pick]="!detail" [attr.role]="detail ? null : 'button'" [attr.tabindex]="detail ? null : 0"
         [attr.aria-pressed]="detail ? null : selectedIa === v.ia" [attr.title]="detail ? null : ('ADMIN_KNX_TOPO_PICK' | translate)"
         (click)="pickFromList(v.ia, detail)" (keydown.enter)="pickFromList(v.ia, detail, $event)"
         (keydown.space)="pickFromList(v.ia, detail, $event)">
      <span class="knxt-dot"></span>
      <span class="mono fw-semibold">{{ v.ia }}</span>
      <span class="knxt-role" [title]="v.roleTitle">{{ v.roleLabel }}</span>
      <span *ngIf="v.conf !== null" class="knxt-conf" [title]="'ADMIN_KNX_TOPO_CONFIDENCE' | translate"><span class="knxm-bar-bg"><span [style.width.%]="v.conf"></span></span>{{ v.conf }} %</span>
      <span class="knxm-stats ms-auto" [title]="v.lastFull">{{ v.count }}<ng-container *ngIf="v.ago"> · {{ 'UPDATED_AGO' | translate:{ time: v.ago } }}</ng-container></span>
    </div>
    <!-- Product from the read-only line scan; the badge's hover/focus card lists the sources as links -->
    <div *ngIf="v.ident as id" class="knxi-row">
      <span class="knxi-mfr">{{ id.mfr }}</span>
      <span class="knxi-prod" [class.knxi-unknown]="!id.known" [title]="id.product">{{ id.bare }}</span>
      <span class="knxi-badge" tabindex="0" [attr.aria-label]="('ADMIN_KNX_ID_CONF' | translate) + ': ' + id.confLabel">
        <span class="badge knxi-c" [ngClass]="'knxi-c-' + id.conf">{{ id.confLabel }}</span>
        <span class="knxi-pop" role="tooltip">
          <span class="knxi-pop-head">{{ ('ADMIN_KNX_ID_CONF_' + (id.conf | uppercase) + '_HINT') | translate }}</span>
          <span *ngIf="id.basis" class="knxi-src">{{ 'ADMIN_KNX_ID_BASIS' | translate }}: {{ id.basis }}</span>
          <ng-container *ngIf="id.sources.length; else noSources">
            <span class="knxi-pop-head">{{ 'ADMIN_KNX_ID_SOURCES' | translate }}</span>
            <span *ngFor="let s of id.sources; trackBy: trackSrc" class="knxi-src">
              <a *ngIf="s.url" [href]="s.url" target="_blank" rel="noopener noreferrer" [title]="s.title">{{ s.text }} ↗</a>
              <ng-container *ngIf="!s.url">{{ s.text }}</ng-container>
            </span>
          </ng-container>
          <ng-template #noSources><span class="knxi-src">{{ 'ADMIN_KNX_ID_NO_SOURCES' | translate }}</span></ng-template>
        </span>
      </span>
      <span *ngIf="id.type" class="knxi-type">{{ id.type }}</span>
      <button type="button" class="btn btn-link knxi-more" (click)="toggleIdent((detail ? 'c' : 'l') + v.ia)"
              [attr.aria-expanded]="!!identOpen[(detail ? 'c' : 'l') + v.ia]">{{ 'ADMIN_KNX_ID_DETAILS' | translate }} {{ identOpen[(detail ? 'c' : 'l') + v.ia] ? '▴' : '▾' }}</button>
    </div>
    <div *ngIf="v.ident && identOpen[(detail ? 'c' : 'l') + v.ia]" class="knxi-details">
      <div class="knxm-kv">
        <ng-container *ngFor="let r of v.ident.rows">
          <span class="text-muted">{{ r.k }}</span><span [class.mono]="r.mono">{{ r.v }}</span>
        </ng-container>
        <ng-container *ngIf="v.ident.sources.length">
          <span class="text-muted">{{ 'ADMIN_KNX_ID_SOURCES' | translate }}</span>
          <span>
            <span *ngFor="let s of v.ident.sources; trackBy: trackSrc; let last = last" class="knxi-src">
              <a *ngIf="s.url" [href]="s.url" target="_blank" rel="noopener noreferrer" [title]="s.title">{{ s.text }} ↗</a>
              <ng-container *ngIf="!s.url">{{ s.text }}</ng-container><br *ngIf="!last">
            </span>
          </span>
        </ng-container>
      </div>
    </div>
    <div *ngIf="v.notInScan" class="knxi-row knxi-unknown">{{ 'ADMIN_KNX_ID_NOT_IN_SCAN' | translate }}</div>
    <div *ngIf="v.notProbed" class="knxi-row knxi-unknown">{{ v.notProbed }}</div>
    <!-- A scan-only device's reasons are the same generic note everywhere: in the list its role says it, the card spells it out -->
    <ul *ngIf="v.reasons.length && (detail || !v.silent)" class="knxt-reasons">
      <li *ngFor="let r of v.reasons">{{ r }}</li>
    </ul>
    <div *ngIf="detail && v.firstFull" class="knxm-hint mt-1">{{ 'ADMIN_KNX_TOPO_SEEN' | translate:{ first: v.firstFull, last: v.lastFull || '–' } }}</div>
    <div *ngIf="v.gas.length" class="knxt-tbl-wrap">
      <table class="table table-sm knxt-tbl knxt-gas">
        <thead>
          <tr>
            <th class="w-ga">{{ 'ADMIN_KNX_COL_GA' | translate }}</th>
            <th>{{ 'ADMIN_KNX_COL_NAME_ONLY' | translate }}</th>
            <th class="w-dpt">DPT</th>
            <th class="w-val">{{ 'ADMIN_KNX_COL_LAST_VALUE' | translate }}</th>
            <th class="w-iv">{{ 'ADMIN_KNX_TOPO_INTERVAL' | translate }}</th>
            <th class="w-n text-end">{{ 'ADMIN_KNX_COL_COUNT' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let g of v.gas; trackBy: trackTopoGa">
            <td class="mono nowrap c-ga">{{ g.g.ga }}</td>
            <td class="knxm-name c-name">
              <ng-container *ngIf="!g.sug">{{ g.name || '–' }}</ng-container>
              <span *ngIf="g.sug" [title]="sugTitle"><span class="knxm-sugg">~ {{ g.name }}</span><span class="badge knxm-sugg-badge">{{ sugBadge[g.sug] }}</span></span>
            </td>
            <td class="nowrap c-dpt">
              <span *ngIf="g.dptLabel" class="badge knxm-dpt" [ngClass]="g.g.dptGuessed ? 'knxm-dpt-guess' : 'knxm-dpt-book'"
                    [title]="g.g.dptGuessed ? guessedTitle : 'DPT ' + g.g.dpt">{{ g.dptLabel }}</span>
            </td>
            <td class="c-last">{{ g.g.lastText || '–' }}</td>
            <td class="nowrap c-iv"><span class="knxm-lbl">{{ lbl.interval }}</span>{{ g.interval }}<span *ngIf="g.g.pwm" class="badge knxt-pwm" [title]="'ADMIN_KNX_TOPO_PWM_HINT' | translate">PWM</span></td>
            <td class="knxm-num c-count"><span class="knxm-lbl">{{ lbl.count }}</span>{{ g.count }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</ng-template>
